/*!
 * Copyright © 2023. Verizon Connect Ireland Limited. All rights reserved.
 */

import { GoogleMapsShapeUtils } from '../../../utils/google-maps-shapes.utils';
import { EGeofenceActions, GeofenceActions } from './geofence.actions';
import { IGeofenceState, initialGeofenceState } from './geofence.state';

export function geofenceReducer(state = initialGeofenceState, action: GeofenceActions): IGeofenceState {
  switch (action.type) {
    case EGeofenceActions.SetGeofenceLatLng: {
      return {
        ...state,
        geofenceLatLng: action.payload
      };
    }

    case EGeofenceActions.ResetGeofenceState: {
      return initialGeofenceState;
    }

    case EGeofenceActions.SetGeofenceDrawingControlShape: {
      return {
        ...state,
        drawingControlShape: action.payload
      };
    }

    case EGeofenceActions.SetGeofenceDrawingControlClearPressed: {
      return {
        ...state,
        drawingControlClearPressed: action.payload
      };
    }

    case EGeofenceActions.SetSelectedGeofenceShape: {
      return {
        ...state,
        currentShape: action.payload,
        geofenceLatLng: action.payload ? GoogleMapsShapeUtils.getLatLngFromShape(action.payload) : null
      };
    }

    case EGeofenceActions.DrawingControlClearPressed: {
      return {
        ...state,
        drawingControlClearPressed: new Date()
      };
    }

    case EGeofenceActions.GetGeofenceAddress: {
      return {
        ...state,
        geofenceLatLng: action.payload
      };
    }

    case EGeofenceActions.GetGeofenceAddressSuccess: {
      return {
        ...state,
        geofenceAddress: action.payload
      };
    }

    case EGeofenceActions.GetPlaceDropdownCategoriesSuccess: {
      return {
        ...state,
        placeDropdownCategories: action.payload
      };
    }

    case EGeofenceActions.SetGeofenceCreateOpen: {
      return {
        ...state,
        geofenceCreateOpen: action.payload
      };
    }

    case EGeofenceActions.ShowExistingGeofenceForEdit: {
      return {
        ...state,
        placeLoaded: action.payload
      };
    }

    default:
      return state;
  }
}
